/**
 * reviewPromptConstants — thresholds, URLs and campaign helpers for the
 * in-app review solicitation feature.
 *
 * Triggers are NEUTRAL usage milestones (never sentiment filters) — everyone
 * who crosses a threshold gets the same ask. See
 * `docs/superpowers/specs/2026-07-03-review-prompt-design.md`.
 */

/** Successful-query count that arms the milestone toast + card. */
export const QUERY_MILESTONE = 100;

/** App-session count required (with tenure) to arm the passive card. */
export const SESSION_THRESHOLD = 10;

/** Days since first launch required (with sessions) to arm via tenure. */
export const TENURE_DAYS = 14;

/**
 * Auto-retirement: after the armed card has been SHOWN in this many app
 * sessions without a click or dismissal, the next boot retires it
 * (`dismissedBy: 'auto'`). Ignoring the ask five times is an answer — the
 * card must not nag forever.
 */
export const CARD_MAX_SHOWN_SESSIONS = 5;

/**
 * Website chooser page. In-app links never point at review sites directly —
 * shipped binaries can't be re-pointed, so everything routes through this page.
 */
export const REVIEW_URL_BASE = 'https://jamsql.com/review/';

/** UTM campaign tags — one per surface that links to the chooser page. */
export type ReviewCampaign =
  | 'milestone-toast'
  | 'start-page-card'
  | 'help-feedback-dialog'
  | 'whats-new';

/**
 * Build the chooser-page URL for a given surface, tagged with UTM params so
 * we can attribute review clicks by surface. Always
 * `${REVIEW_URL_BASE}?utm_source=app&utm_medium=referral&utm_campaign=<campaign>`.
 */
export function reviewUrl(campaign: ReviewCampaign): string {
  return `${REVIEW_URL_BASE}?utm_source=app&utm_medium=referral&utm_campaign=${campaign}`;
}
